import { render, staticRenderFns } from "./PatNotificationLog.vue?vue&type=template&id=dbc561cc&scoped=true"
import script from "./PatNotificationLog.vue?vue&type=script&lang=js"
export * from "./PatNotificationLog.vue?vue&type=script&lang=js"
import style0 from "./PatNotificationLog.vue?vue&type=style&index=0&id=dbc561cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc561cc",
  null
  
)

export default component.exports